// extracted by mini-css-extract-plugin
module.exports = {"content":"TextTime_content__AjjuH","text":"TextTime_text__3K4s6","time":"TextTime_time__29SWC","fullContent":"TextTime_fullContent__2plgy"};